import SignUp from "views/SignUpView";

export default function Page() {
  return (
    <>
      <SignUp />
    </>
  );
}
